module.exports = __webpack_public_path__ + "static/media/button-go-next-page.5797c585.png";